module.exports = __webpack_public_path__ + "img/workNewsCover1.a906afa8.png";